import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "width", "height"]

import { computed, ref } from "vue";
import { spacerUrl } from "./empty-pixel";

const lorem =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sagittis mattis quam in porta. Donec a.";


export default /*@__PURE__*/_defineComponent({
  __name: 'Filler',
  props: {
    min: {
        type: Number,
        default: 10,
    },
    max: {
        type: Number,
        default: 100,
    },
    box: {
        type: Boolean,
        default: false,
    },
    img: {
        type: Boolean,
        default: false,
    },
    aspectRatio: {
        type: String,
        default: "",
    },
    realLetters: Boolean,
    width: [Number, String],
    height: [Number, String],
    tag: {
        type: String,
        default: "div",
    },
    txt: Boolean,
},
  setup(__props) {

const props = __props;

const text = ref(generateText());

const classes = computed(() => {
    return {
        filler: true,
        "with-scroller": !props.txt,
        box: props.box,
        "inline-block": !props.box && !props.txt,
    };
});

function pixelString(v: number | string) {
    if (typeof v === "number") return v + "px";
    if (!v.endsWith("px") && !v.endsWith("%")) return v + "px";
    return v;
}

const styles = computed(() => {
    const style: { [key: string]: string } = {};
    if (props.aspectRatio != "") {
        style["aspect-ratio"] = props.aspectRatio;
    }
    if (props.width != null) {
        style["width"] = pixelString(props.width);
    }
    if (props.height != null) {
        style["height"] = pixelString(props.height);
    }
    if (props.realLetters) {
        style["color"] = "transparent";
    }
    return style;
});

function generateText() {
    if (props.box || props.img) return "";
    const length = rand(props.min, props.max);
    if (length === 0) return "";
    if (props.realLetters) {
        return lorem.substring(0, length);
    }
    let val = "";
    for (let i = 0; i < length; i++) {
        if (i > 0 && i % 7 === 0) {
            val += " ";
        } else {
            val += "\xa0";
        }
    }
    return val;
}

function rand(min: number, max: number, round = true) {
    const width = max - min;
    let val = min + Math.random() * width;
    if (round) val = ~~val;
    return val;
}

return (_ctx: any,_cache: any) => {
  return (__props.img)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _unref(spacerUrl),
        width: __props.width,
        height: __props.height
      }, null, 8 /* PROPS */, _hoisted_1))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
        key: 1,
        class: _normalizeClass(classes.value),
        style: _normalizeStyle(styles.value)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(text.value), 1 /* TEXT */)
        ], undefined, true),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class", "style"]))
}
}

})